import ModalsHeadline from "../components/ModalsHeadline";

const UploadParcelPictures = ({ handleShowModal }) => {
  return (
    <div className="flex flex-col justify-between rounded-lg h-full">
      <div>
        <ModalsHeadline text="Upload photos" onClick={handleShowModal} />
      </div>
    </div>
  );
};

export default UploadParcelPictures;
